import { Flex } from "antd";
import { ProfileForm } from "@/entities/profile-form";
import { ChangeOldPasswordForm } from "@/entities/change-old-password-form";
import { SubscriptionBlock } from "@/entities/subscription-block";
import { SettingsTopBar } from "@/shared/Components";
import styles from "./styles.module.scss";

export const SettingsPageDesktop = () => {
  return (
    <div className={styles.root}>
      <SettingsTopBar />
      <Flex className={styles.content} gap={40}>
        <ProfileForm />
        <ChangeOldPasswordForm />
        <SubscriptionBlock />
      </Flex>
    </div>
  );
};
